import http from "@/plugins/Axios";

export default {
  actions: {
    async getContracts(_, query) {
      try {
        const params = query || {};
        let {
          data: { data, total },
        } = await http.get("contract/list", {
          params,
        });
        data = data.map((item, index) => {
          if (query) item.index = index + 1 + (query.page - 1) * query.limit;
          item.loading = false;
          item.show = false;
          item.children = [];
          return item;
        });
        return {
          data,
          total,
          lastPage:
            params && params.limit ? Math.ceil(total / params.limit) : null,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};
